import { render, staticRenderFns } from "./SetupDetails.vue?vue&type=template&id=6616470f&"
import script from "./SetupDetails.vue?vue&type=script&lang=js&"
export * from "./SetupDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetupDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6616470f')) {
      api.createRecord('6616470f', component.options)
    } else {
      api.reload('6616470f', component.options)
    }
    module.hot.accept("./SetupDetails.vue?vue&type=template&id=6616470f&", function () {
      api.rerender('6616470f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Setups/SetupDetails.vue"
export default component.exports